/**
 * The external API reference is a platform page (`/docs/api`) rendered from the spec that
 * hapi-swagger generates out of the `/v1` route definitions. The page reads that spec through a
 * same-origin endpoint, because the platform domain routes only `/api/*` and `/v1/*` to upserve;
 * `/swagger.json` lives on the API host alone.
 */
export const EXTERNAL_API_DOCS_UI_PATH = '/docs/api';
/** Under upserve's `/api` prefix, which the UI's `fetchOrThrow` adds itself. */
export const EXTERNAL_API_DOCS_SPEC_API_PATH = '/external-api-docs/spec';

/**
 * Launch gate for the platform API reference (PLT-6933). While `true`, `/docs/api` is public and
 * `api.uprightproject.com/documentation` redirects to it; the redirect keeps the URL fragment, and
 * the page answers ReDoc's `#tag/…`, `#operation/…` and `#section/…` anchors, so existing deep links
 * keep landing. Set back to `false` to restore ReDoc and make the page team-only again.
 */
// Widened to `boolean` so the code on both sides of the gate type-checks as live while the value is fixed.
export const isPlatformApiDocsLaunched = true as boolean;
